import type { Skill, SkillStore } from '../../ports/skills'
import { BackendError } from '../../errors'
import { delay, uid } from './util'

const SEED: Skill[] = [
  {
    id: 's_doc',
    command: '/dokument-prüfen',
    name: 'Dokument prüfen',
    description: 'Prüft das gesamte Dokument auf Fehler.',
    enabled: true,
    source: 'local',
    host: 'word',
  },
  {
    id: 's_lektorat',
    command: '/lektorat',
    name: 'Lektorat',
    description: 'Korrigiert Stil, Grammatik und Rechtschreibung.',
    enabled: true,
    source: 'local',
    host: 'all',
  },
  {
    id: 's_dsgvo',
    command: '/dsgvo-check',
    name: 'DSGVO-Check',
    description: 'Markiert datenschutzrechtliche Risiken.',
    enabled: true,
    source: 'server',
    host: 'all',
  },
  {
    id: 's_vertrag',
    command: '/vertrag-zusammenfassen',
    name: 'Vertrag zusammenfassen',
    description: 'Erstellt eine Kurzfassung des Vertrags.',
    enabled: false,
    source: 'local',
    host: 'word',
  },
  {
    id: 's_probleme',
    command: '/probleme-markieren',
    name: 'Probleme markieren',
    description: 'Hebt unklare oder riskante Stellen hervor.',
    enabled: true,
    source: 'local',
    host: 'all',
  },
]

export class MockSkillStore implements SkillStore {
  private skills: Skill[] = SEED.map((s) => ({ ...s }))

  constructor(private readonly latency: number) {}

  async list(): Promise<Skill[]> {
    await delay(this.latency)
    return [...this.skills]
  }

  async setEnabled(id: string, enabled: boolean): Promise<Skill> {
    await delay(this.latency)
    const s = this.skills.find((x) => x.id === id)
    if (!s) throw new BackendError({ code: 'not_found', message: `Skill ${id} not found` })
    s.enabled = enabled
    return s
  }

  async create(input: Omit<Skill, 'id' | 'source'>): Promise<Skill> {
    await delay(this.latency)
    const s: Skill = { ...input, id: uid('s'), source: 'local' }
    this.skills.push(s)
    return s
  }

  async update(id: string, patch: Partial<Skill>): Promise<Skill> {
    await delay(this.latency)
    const s = this.skills.find((x) => x.id === id)
    if (!s) throw new BackendError({ code: 'not_found', message: `Skill ${id} not found` })
    Object.assign(s, patch)
    return s
  }

  async delete(id: string): Promise<void> {
    await delay(this.latency)
    this.skills = this.skills.filter((x) => x.id !== id)
  }
}
